import React, { useEffect, useState } from "react";
import ScheduleInfo from "./ScheduleInfo";
import { Control, FieldErrors, useForm } from "react-hook-form";


import SuccessModel from "./SuccessModel";
import Button from "../global/Button";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../skeletons/Loader";
import { AppDispatch } from "../../lib/redux/store";
import { addLeagueInfo, reset } from "../../lib/redux/slices/leagueSlice";
import Modal from "../global/Modal";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";
import { toast } from "react-toastify";
import {
  useCreateLeagueMutation,
  useCreateTournamentMutation,
  useEditLeagueMutation,
  useEditTournamentMutation,
  useGetLeagueByIdQuery,
  useGenerateGroupMatchesForTournamentMutation,
  useGenerateGroupMatchesMutation,
  useScheduleTournamentMutation,
  useScheduleLeagueMutation,
  useEditEventMutation,
  useGenerateEventMatchesMutation,
  useGetEventByIdQuery,
} from "../../lib/redux/services/Api";
import { toastMessage } from "../../utils/utils";
import AvailableCourtsTableNew from "../events/AvailableCourtsTableNew";
import ProgressModal from "../global/ProgressModal";
import ScheduleInfoV2 from "./V2/ScheduleInfoV2";
import { UserSliceType } from "../../lib/redux/slices/userSlice";
import ScheduleInfoNew from "./ScheduleInfoNew";

type propsType = {
  type: "public" | "private";
  eventType: "edit" | "new" | "duplicate" | "view";
};
type FormType = {
  //   required_courts: number;
  //   pause_time: number;
  //   match_duration: number;
  //   number_of_serves: number;
  //   total_price?: number;
  //   payment_method_id?: any;

  name: string;
  tournament_type: "Americano" | "Mexicano" | "King of the Courts";
  available_courts: number[];
  state: "Pending" | "Draft"; // should be in the system
  organizer_name: string; // char
  club_id: number; // should be in the system
  resource_calendar_id: 2; // should be in the system
  description: string;
  poster: string;
  sponsor_ids: [
    {
      name: string;
      logo: string;
    },
  ];
  prize_ids: [
    {
      name: string;
      //  "logo": string
    },
  ];
  min_number_of_players: number; // integer
  max_number_of_players: number; // integer
  contact_person?: string;
  email?: string;

  phone?: string;
  total_price?: number;
  payment_method_id?: number;
  min_players_level: number; // integer
  max_players_level: number; // integer
  price_per_player: number; // float
  players_gender: "Mixed" | "Male" | "Female"; // should be in the system
  join_type: "Both" | "Single" | "Double"; // should be in the system
  terms_and_conditions: string;
  waiting_list?: true; // if Typed True or true or 1 means true anything else means false
  start_date: string;
  number_of_serves: number;
  end_date: string;
  game_type: "competitive" | "friendly";
  registration_deadline_date: string;
  excluded_days: string[]; // should be list of dates exactly like this
  set_per_match: "1" | "3";
  court_ids: number[]; // should exists in the system  // should be added if tournament type is not King of courts other wise send court_ids
  court_type: "indoor" | "outdoor"; // for public events, options: (indoor, outdoor)
  // "courts_priority_ids": [ // should be added if tournament type is King of courts other wise send court_ids
  //     {
  //         "court_id": 4,
  //         "priority": 1
  //     },
  //     {
  //         "court_id": 17,
  //         "priority": 2
  //     }
  // ],
  selects_days: string[];
  pause_time: number;
  start_time: string;
  not_allowed_lines: number[];
  end_time: string;
  required_courts: number;
  courts_priority_ids: { court_id: number; priority: number }[];
  event_type?: "public" | "private";
  available_courts_ids: number[];
  unwanted_courts: number[];
  managed_by: "club" | "client";
  match_duration: number; // float
  organizer_ids: any;
};

const CreateEventSecondStepFormV2 = ({ type, eventType }: propsType) => {
  const param = useParams();
  const [editEvent] = useEditEventMutation();
  const editFunction = editEvent;
    const [selectedCourtsLength, setSelectedCourtsLength] = useState<number>(0);
    const [matchCount, setMatchCount] = useState<number>(0);
  const [Id, setId] = useState<number | string>(0);
  const [name, setName] = useState<string>("");
  const [isLoadingMatches, setIsloadingMatches] = useState(false);
  const [loadingModalTitle, setLoadingModalTitle] = useState("Saving courts");
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [availableCourtsParams, setAvailableCourtsParams] = useState<any>({});
  const { id } = useParams();
  const [availableCourtsLoading, setAvailableCourtsLoading] =
    useState<boolean>(false);
  const [notAllowedToComplete, setNotAllowedToComplete] = useState<number[]>(
    [],
  );
  const [generateEventMatches] = useGenerateEventMatchesMutation();
  const navigate = useNavigate();
  const [selectedCourts, setSelectedCourts] = useState<{ [key: string]: [] }>(
    {},
  );
  const [courts, setCourts] = useState([]);
  const [isAllow, setIsAllow] = useState(true);
  const { shared }: DictionaryType = useGetDictionary();

  const selectedClub = useSelector(
    (state: UserSliceType) => state.user.selectedClub,
  );

  const { data, isLoading, isFetching } = useGetEventByIdQuery(param.id, {
    skip: !param.id,
  });

  const defaultTournament = {
    name: "", // should be in the system
    organizer_name: "", // char
    club_id: selectedClub, // should be in the system
    resource_calendar_id: 0, // should be in the system
    description: "",
    available_courts: [],
    unwanted_courts: [],
    available_courts_ids: [],

    poster: "",
    sponsor_ids: [
      {
        name: null,
        logo: "",
      },
    ],
    prize_ids: [
      {
        name: "",
        // logo is commented out as per the example
      },
    ],

    required_courts: 0,
    pause_time: 0,
    managed_by: "club",

    registration_deadline_date: "",
    terms_and_conditions: "",
    waiting_list: true, // default true
    start_date: "",
    end_date: "",
    excluded_days: [], // list of dates
    set_per_match: "1",
    court_ids: [], // should exist in the system
    court_type: "indoor", // for public events
    selects_days: [],
    courts_priority_ids: [{ court_id: "", priority: 1 }],
    event_type: type,
    start_time: "",
    end_time: "",
  };

  const {
    control,
    handleSubmit,
    register,
    setValue,
    trigger,

    getValues,
    reset: resetForm,
    formState: { errors, isDirty },
    watch,
  } = useForm<FormType>({
    // disabled: eventType == "view" ? true : false,
    //we want to set the pasue time to 0 by default and we hide the pause_time field
    defaultValues: { ...defaultTournament, ...data?.data, pause_time: 0 },
  });

  useEffect(() => {
    if (data?.data) {
      resetForm(data.data);
    }

    if (eventType === "view") {
      setIsAllow(false);
      return;
    }
    // if (
    //   eventType === "edit" &&
    //   watch("state") &&
    //   //@ts-ignore
    //   watch("state") !== "" &&
    //   watch("state") !== "Draft" &&
    //   watch("state") !== "Pending"
    // ) {
    //   setIsAllow(false);
    // }
  }, [data]);

  // useEffect(() => {
  //   if (eventType === "view") {
  //     setIsAllow(false);
  //     return;
  //   }
  //   if (
  //     eventType === "edit" &&
  //     watch("state") &&
  //     //@ts-ignore
  //     watch("state") !== "" &&
  //     watch("state") !== "Draft"
  //   ) {
  //     setIsAllow(false);
  //   }
  // }, [eventType, data]);

  const refactor_available_courts = (
    data: any,
    max_number_of_players: number,
  ) => {
    const available_courts_stack = [];
    const selectedCourts = new Set();
    let isValid = true;
    if (data.tournament_type === "King of the Courts") {
      for (let i = 0; i < data.available_courts_ids.length; i++) {
        available_courts_stack.push({
          id: data.available_courts_ids[i],
          court_ids: data.courts_priority_ids.map((item: any) => item.court_id),
        });
      }
      for (let i = 0; i < data.courts_priority_ids.length; i++) {
        selectedCourts.add(data.courts_priority_ids[i].court_id);
        if (data.courts_priority_ids[i].court_id === 0) {
          isValid = false;
        }
      }
    } else {
      for (let keys of Object.keys(data.available_courts)) {
        if (
          data.available_courts[keys].length <
          Math.ceil(max_number_of_players / 4)
        ) {
          isValid = false;
        }
        if (watch("unwanted_courts")?.includes(parseInt(keys))) {
          delete data.available_courts[keys];
        } else {
          available_courts_stack.push({
            id: parseInt(keys),
            court_ids: data.available_courts[keys].map((item: any) => {
              selectedCourts.add(item.id);
              return item.id;
            }),
          });
        }
      }
    }

    return {
      available_courts: available_courts_stack,
      selectedCourts: Array.from(selectedCourts),
      isValid,
    };
  };

  const generateMatchesHandler = async () => {
    setLoadingModalTitle("Generating matches");
    try {
      await toast.promise(
        generateEventMatches({ league_id: param.id }).unwrap(),
        toastMessage(
          "Generating matches… may take up to 2 min. Please stay on this page.",
        ),
      );
      setIsloadingMatches(false);
      setLoadingModalTitle("Saving courts");
      navigate(`/friendly/${type}/rounds/${param.id}`);
    } catch (error) {
      console.error("Error:", error);
      setIsloadingMatches(false);
      setLoadingModalTitle("Saving courts");
    }
  };

  const onSubmit = async (data: FormType, state: any) => {
    console.log(data);
    console.log(state);
    const { not_allowed_lines, ...formData } = data;

    try {
      if (state && data.available_courts.length !== undefined) {
        //@ts-ignore
        let available_courts = [];
        //@ts-ignore
        let court_ids = [];
        const refactor_available_courts_data = refactor_available_courts(
          data,
          data.max_number_of_players,
        );
        court_ids = refactor_available_courts_data.selectedCourts.filter(
          (item: any) => item !== 0,
        );
        available_courts = refactor_available_courts_data.available_courts;
        if (state !== "Draft") {
          if (!refactor_available_courts_data.isValid) {
            toast.error(
              `Please select at least ${Math.ceil(
                data.max_number_of_players / 4,
              )} court in each Row`,
            );
            return false;
          }
          if (
            refactor_available_courts_data &&
            refactor_available_courts_data.available_courts.length <
              data.available_courts_ids.length
          ) {
            toast.error(
              `Please select at least ${Math.ceil(
                data.max_number_of_players / 4,
              )} court in each Row, you have ${
                data.available_courts_ids.length -
                refactor_available_courts_data.available_courts.length
              } courts left`,
            );
            return false;
          }
        } else {
          available_courts = [];
          court_ids = [];
        }

        if (eventType === "edit" && param.id) {
          console.log("hhh");
          setIsloadingMatches(true);
          await toast
            .promise(
              ///@ts-ignore
              editFunction({
                data: {
                  ...formData,
                  organizer_ids: formData?.organizer_ids?.map((item: any) =>
                    item?.id ? item.id : item,
                  ),
                  sponsor_ids: formData.sponsor_ids.filter(
                    (item: any) => item.logo || item.name,
                  ),
                  prize_ids: formData.prize_ids.filter(
                    (item: any) => item.logo || item.name,
                  ),
                  state: state,
                  //@ts-ignore
                  available_courts: available_courts,
                  //@ts-ignore
                  court_ids: court_ids,
                  ///@ts-ignore
                  club_id: selectedClub,
                  //we want to set the pasue time to 0 by default and we hide the pause_time field
                  pause_time: 0,
                },
                id: param.id,
              })
                .unwrap()
                .then((res: any) => {
                  //@ts-ignore
                  setId(param.id);
                  setName(data.name);
                }),
              toastMessage(),
            )
            .then(() => {
              if (
                state !== "Draft" &&
                (data.state === "Draft" || data.state === undefined)
              ) {
                setOpenModal(true);
              } else {
                //@ts-ignore
                resetForm(defaultTournament);
                generateMatchesHandler();
                // navigate(`/friendly/${type}`);
              }
            });

          return;
        }
      } else {
        console.log("xxx");
        const refactor_available_courts_data = refactor_available_courts(
          data,
          data.max_number_of_players,
        );
        console.log("xxx2");
        if (eventType === "edit" && param.id) {
          if (state !== "Draft") {
            if (!refactor_available_courts_data.isValid) {
              toast.error(
                `Please select at least ${Math.ceil(
                  data.max_number_of_players / 4,
                )} court in each Row`,
              );
              return false;
            }
            if (
              refactor_available_courts_data &&
              refactor_available_courts_data.available_courts.length <
                data.available_courts_ids.length
            ) {
              toast.error(
                `Please select at least ${Math.ceil(
                  data.max_number_of_players / 4,
                )} court in each Row, you have ${
                  data.available_courts_ids.length -
                  refactor_available_courts_data.available_courts.length
                } courts left`,
              );
              return false;
            }
          }

          setIsloadingMatches(true);
          await toast
            .promise(
              ///@ts-ignore
              editFunction({
                data: {
                  ...formData,
                  organizer_ids: formData?.organizer_ids?.map((item: any) =>
                    item?.id ? item.id : item,
                  ),
                  sponsor_ids: formData.sponsor_ids.filter(
                    (item: any) => item.logo || item.name,
                  ),
                  prize_ids: formData.prize_ids.filter(
                    (item: any) => item.logo || item.name,
                  ),
                  state: state,
                  court_ids:
                    state === "Draft"
                      ? []
                      : refactor_available_courts_data.selectedCourts.filter(
                          (item: any) => item !== 0,
                        ),
                  available_courts:
                    state === "Draft"
                      ? []
                      : refactor_available_courts_data.available_courts,
                  event_type: data.event_type?.toLowerCase(),
                  club_id: selectedClub,
                  //we want to set the pasue time to 0 by default and we hide the pause_time field
                  pause_time: 0,
                },
                id: param.id,
              })
                .unwrap()
                .then((res: any) => {
                  param.id && setId(param.id);
                  setName(data.name);
                }),
              toastMessage(),
            )
            .then(() => {
              if (
                state !== "Draft" &&
                //@ts-ignore
                (data.state === "Draft" || data.state === undefined)
              ) {
                //@ts-ignore
                resetForm(defaultTournament);
                setOpenModal(true);
              } else {
                //@ts-ignore
                resetForm(defaultTournament);
                generateMatchesHandler();
                // navigate(`/friendly/${type}`);
              }
            });

          return;
        }
        // else {
        //   const refactor_available_courts_data = refactor_available_courts(
        //     data,
        //     data.max_number_of_players
        //   );
        //   await toast.promise(
        //     ///@ts-ignore
        //     createFunction({
        //       ...data,
        //       court_ids: refactor_available_courts_data.selectedCourts,
        //       available_courts: refactor_available_courts_data.available_courts,
        //       event_type: data.event_type?.toLowerCase(),
        //     })
        //       .unwrap()
        //       .then((res) => {
        //         setId(res.data.id);
        //         setName(data.name);
        //       }),
        //     toastMessage()
        //   );
        //   navigate(`/friendly/${type}`);
        // }
      }
    } catch (error) {
      //@ts-ignore
      resetForm(data?.data || defaultTournament);
    }
  };

  if (isFetching) return <Loader />;

  return (
    <div className="grid grid-cols-4 gap-[20px]">
      <div className="col-span-4 max-h-[calc(100dvh-220px)] overflow-y-auto hidden-customScroll  pt-3 px-5 flex flex-col gap-5">
        <div className="grid grid-cols-4 gap-[20px] w-full col-span-4">
          <div className="col-span-3">
              <ScheduleInfoV2
          type={type}
          control={control}
          errors={errors}
          register={register}
          watch={watch}
          setValue={setValue}
          trigger={trigger}
          setAvailableCourts={setAvailableCourtsParams}
          isAllow={isAllow}
          setAvailableCourtsLoading={setAvailableCourtsLoading}
          getValue={getValues}
          setCourts={setCourts}
          data={data?.data}
          setSelectedCourts={setSelectedCourts}
          selectedCourts={selectedCourts}
          eventType={eventType}
        />
          </div>
        
         <div className="col-span-1 h-[350px] w-full bg-primary rounded-2xl py-[34px] px-[26px] text-white flex flex-col gap-[23px] overflow-y-auto customScroll">
        <div>
          <span className="text-[#CCCCCC]">Summary</span>
          <h3 className="font-bold text-[24px]">{watch("name")}</h3>
          <p className="font-normal text-[#F3F3F3] text-[16px]">
            {watch("tournament_type")} Rounds .{" "}
            {watch("max_number_of_players") / 2} teams
          </p>
        </div>

        <div className="grid gap-[23px]">
          <div className="border-b border-white/50 pb-5 flex justify-between items-center text-[16px] font-bold">
            <p>Number of courts</p>
            <p>{watch("max_number_of_players")/4}</p>
          </div>
          <div className="border-b border-white/50 pb-5 flex justify-between items-center text-[16px] font-bold">
            <p>Maximum duration of rounds</p>
            <p>{watch("match_duration")} min</p>
          </div>
        
          <div className="border-b border-white/50 pb-5 flex justify-between items-center text-[16px] font-bold">
            <p>number of serve</p>
            <p className="text-primaryYellow">{watch("number_of_serves")}</p>
          </div>
           <div className="border-b border-white/50 pb-5 flex justify-between items-center text-[16px] font-bold">
            <p>Selected date</p>
            <p>
              {watch("start_date")} 
            </p>
          </div>
        </div>
      </div>
        </div>
        
        <AvailableCourtsTableNew
          isAllow={isAllow}
          setMatchCount={setMatchCount}
          availableCourtsParams={availableCourtsParams}
          setAvailableCourtsLoading={setAvailableCourtsLoading}
          availableCourtsLoading={availableCourtsLoading}
          control={control}
          setNotAllowedToComplete={setNotAllowedToComplete}
        
          notAllowedToComplete={notAllowedToComplete}
          
          getValue={getValues}
          watch={watch}
          selectedCourtsLength={selectedCourtsLength}
          setSelectedCourtsLength={setSelectedCourtsLength}
          selectedCourts={selectedCourts}
          setSelectedCourts={setSelectedCourts}
          setValue={setValue}
          setAvailableCourtsParams={setAvailableCourtsParams}
          type={type}
          
        />

        <div className=" flex pt-2 gap-3 justify-end w-full items-center pr-4 pb-4">
          {eventType == "view" ? (
            <>
             <Button
              customeStyle=" text-red-500 hover:border hover:border-red-500 p-3 px-2 rounded-full w-[200px]"
              text={shared.back}
              width="150px"
              type="submit"
              onClick={(e) => {
                e.preventDefault();

                navigate(`/friendly/${type}/view/step1/${id}`);
              }}
            />
            <Button
              customeStyle=" text-white bg-primary  p-3 px-2 rounded-full w-[200px]"
              text={"Next"}
              width="150px"
              type="submit"
              onClick={(e) => {
                e.preventDefault();

                navigate(`/friendly/${type}/rounds/${id}`);
              }}
            />
            </>
           
          ) : (
            <>
              <Button
                customeStyle=" text-red-500 hover:border hover:border-red-500 p-3 px-2 rounded-full w-[200px]"
                text={shared.cancel}
                width="150px"
                type="button"
                onClick={(e) => {
                  e.preventDefault();

                  // dispatch(reset());
                  navigate("/friendly/" + type);
                }}
              />
              {(!getValues("state") || getValues("state") === "Draft") && (
                <Button
                  customeStyle=" text-primary dark:text-white  p-3 px-2 rounded-full w-[200px]"
                  text={shared.save_for_later || "save for later"}
                  width="150px"
                  type="button"
                  onClick={async (e) => {
                    e.preventDefault();

                    await onSubmit(getValues(), "Draft");
                  }}
                />
              )}
              <Button
                customeStyle="bg-primary text-white dark:text-primary dark:bg-primaryYellow p-3 px-2 rounded-full w-[200px]"
                text={shared.save_and_publish}
                width="150px"
                type="submit"
                onClick={handleSubmit((formData: FormType) => {
                  if (matchCount > selectedCourtsLength) {
                    toast.error(
                      `Please select ${
                        matchCount - selectedCourtsLength
                      } courts to complete`,
                    );
                    return;
                  }
                  onSubmit(formData, "Pending");
                })}
              />
            </>
          )}
        </div>
        {isLoadingMatches && (
          <Modal
            isOpen={true}
            onClose={() => {
              // dispatch(reset());
              setOpenModal(isLoadingMatches);
            }}
            modalMaxWidth="max-w-[550px]"
          >
            {/* <SuccessModel
            type={type}
            start_date={getValues("start_date")}
            id={Id}
            name={name}
          /> */}
            <ProgressModal
              loadingModalTitle={loadingModalTitle}
              isLoadingMatches={isLoadingMatches}
            />
          </Modal>
        )}
      </div>
     
    </div>
  );
}

export default CreateEventSecondStepFormV2;
